import React from 'react';
import { matchIsValidColor, MuiColorInput } from 'mui-color-input';
import { useController, useFormContext } from 'react-hook-form';

interface ColorInputProps {
  name: string;
}

const ColorInput: React.FC<ColorInputProps> = ({ name }) => {
  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
    defaultValue: '#ffffff',
  });

  const handleChange = (value: string) => {
    // During drag, the picker can emit transient invalid values; ignore those
    // so the controlled value does not snap back and freeze the slider.
    if (!matchIsValidColor(value)) return;
    field.onChange(value);
  };

  return (
    <MuiColorInput
      format="hex"
      isAlphaHidden
      value={field.value ?? '#ffffff'}
      onChange={handleChange}
      sx={{ '& input': { textTransform: 'uppercase' } }}
    />
  );
};

export default ColorInput;
